import { type FC } from 'react';

import clsx from 'clsx';

import { Link, type LinkProps } from '@/components/common/Link';
import { Text, type TextProps } from '@/components/common/Text';

import styles from './TextLink.module.scss';

export type TextLinkProps = Omit<TextProps, 'color'> &
  Pick<LinkProps, 'href' | 'target'> & {
    textClassName?: string;
    variant?: 'green' | 'white-50p';
  };

export const TextLink: FC<TextLinkProps> = (props) => {
  const { className, textClassName, variant = 'green', href, target, ...textProps } = props;

  return (
    <Link className={clsx(styles.root, styles[`variant_${variant}`], className)} href={href} target={target}>
      <Text className={textClassName} {...textProps} />
    </Link>
  );
};
